var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor add-tag" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("a-alert", {
            attrs: {
              type: "info",
              "show-icon": "",
              message:
                "Tags are used to categorize your visitors. You can add tags to your visitors manually or automatically using conditions. You can also use tags to trigger actions in your chatbot.",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Tags to Adding")]),
          _vm._v(" "),
          _c("TagDialog", {
            model: {
              value: _vm.clone.tags,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "tags", $$v)
              },
              expression: "clone.tags",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }